import styled from "styled-components";

export const OverflowContainer = styled.div`
  overflow-x: hidden;
`;
